import React, { useState } from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";
// import { urlFor, client } from '../../client';
import { images } from "../../constants";

const About = () => {
  const [abouts] = useState([
    {
      title: "Shop Advertising  Board",
      imgUrl: images.shop_sign_board,
    },
    {
      title: "Wall Advertising",
      imgUrl: images.wall_advertising1,
    },
    {
      title: "Building Name Board",
      imgUrl: images.building_name_board02,
    },
    {
      title: "Name Plate",
      imgUrl: images.name_plate,
    },
    {
      title: "Cloth Banner",
      imgUrl: images.banner,
    },
    {
      title: "Marathi, Hindi, English Sign Board",
      imgUrl: images.eng_hindi_marathi_service,
    },
  ]);

  // useEffect(() => {
  //   const query = '*[_type == "abouts"]';

  //   client.fetch(query).then((data) => {
  //     setAbouts(data);
  //   });
  // }, []);

  return (
    <>
      <h2 className="head-text">
        I Know that <span>Good Sign Board</span> <br />
        means <span>Good Business</span>
      </h2>

      <div className="app__about_me">
        <motion.div
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, type: "tween" }}
          className="app__profile-content"
        >
          <img src={images.sign_board_painter} alt={"sign-board-painter"} />
          <h2>About Me</h2>
          <h3 className="bold-text">
            Namaste, I'm Ravindranath Kushwaha, a creative Sign Board Painter
            based in Thane, Maharashtra. I've been working as a Sign Board
            Painter for over 30 years and have satisfied 1000+ customers with
            quality Sign Boards that have lasted for many years. <br /> The
            various services that I offer are as follows: shop advertising
            board, sign board painting, vehicle parking, society name board
            maker, wall advertising, name plates painting, cloth banner,
            Marathi, Hindi, English sign board and many more...
          </h3>
        </motion.div>
      </div>

      <h2 style={{ textAlign: "center", marginTop: "20px", fontSize: "30px" }}>
        Services
      </h2>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={about.imgUrl} alt={about.title} />
            {/* <img src={urlFor(about.imgUrl)} alt={about.title} /> */}
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            {/* <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p> */}
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
